/**
 * @description Get current date in format YYYY-MM-DD
 * @returns current date
 */
export function getCurrentDateFormated() {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * @description Parse seconds into hours, minutes and seconds
 * @param recievedSeconds
 * @returns [hours, minutes, seconds]
 */
export function parseTime(recievedSeconds: number): [number, number, number] {
  const hours = Math.floor(recievedSeconds / 3600)
  const minutes = Math.floor((recievedSeconds - hours * 3600) / 60)
  const seconds = recievedSeconds - hours * 3600 - minutes * 60
  return [hours, minutes, seconds]
}

/**
 * Format seconds into human readable time
 * @param seconds
 * @returns formatted time
 */
export function formatHumanTime(seconds: number) {
  const [h, m, s] = parseTime(seconds)
  return `${h} hour${h === 1 ? '' : 's'}, ${m} minute${
    m === 1 ? '' : 's'
  }, ${s} second${s === 1 ? '' : 's'}`
}
